import {Controller} from "@hotwired/stimulus";
import Debug from 'debug';
import SlideoverController from "@root/server/client/esweb/src/lib/stimulus/slideover/slideover.stimulus.ts";

export const name = 'lib--slideover-trigger';

const debug = Debug(`app:${name}`);

export default class extends Controller {
    static values = {
        id: String
    };

    declare idValue: string;

    connect() {

    }

    disconnect() {

    }

    click() {
        const slideoverElement = document.getElementById(this.idValue);
        debug({slideoverElement});
        const slideoverController = this.application.getControllerForElementAndIdentifier(slideoverElement, 'lib--slideover') as SlideoverController;
        debug({slideoverController})
        slideoverController.open();
    }
}